import { makeVar } from "@apollo/client";
import type { User } from "../hooks/useAuth";

export const userVar = makeVar<User | undefined>(undefined);
